// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1_JEU","text":"SelectPayment_text__10wFs","title":"SelectPayment_title__1cPk3","btn":"SelectPayment_btn__29dzU"};